var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkypeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2128_1075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#112765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.92 17.7789C25.1389 12.3052 20.341 7.32837 14.7095 8.28206C11.6505 6.38521 7.57893 8.52837 7.57893 12.1684C7.57721 12.9831 7.79541 13.7831 8.21051 14.4842C7.07788 19.9726 11.9158 24.8757 17.5431 23.8547C21.5284 25.9642 25.9263 21.7684 23.92 17.7789ZM18.5663 21.0799C17.0926 21.6884 14.6547 21.6926 13.1831 20.9221C11.0779 19.8021 10.7116 17.2821 12.5221 17.2821C13.8863 17.2821 13.4547 18.8736 14.8379 19.5221C15.4695 19.8147 16.8295 19.8442 17.6189 19.3115C18.4084 18.7789 18.3158 17.9684 17.8947 17.5747C16.7705 16.5368 13.5558 16.9431 12.0842 15.1326C11.7413 14.6711 11.5584 14.1103 11.5634 13.5354C11.5683 12.9604 11.7608 12.4028 12.1116 11.9473C13.48 10.1852 17.4947 10.0778 19.2231 11.4084C20.8168 12.6421 20.3874 14.28 19.0989 14.28C17.5516 14.28 18.3663 12.2547 15.8674 12.2547C14.0568 12.2547 13.341 13.5431 14.6189 14.1705C16.3537 15.0294 20.7579 14.7368 20.7579 18.1052C20.7579 19.501 19.8989 20.5431 18.5663 21.0863V21.0799Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2128_1075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkypeIcon);
export default __webpack_public_path__ + "static/media/skype_icon.74e5cfb7adb0d6d05e029ccb21412556.svg";
export { ForwardRef as ReactComponent };